export interface Account {
  accountId: string;
  accountKey: string;
  company: string;
  email: string;
  externalID: string;
  firstName: string;
  lastName: string;
  licenseId: string;
  ownerApiKey: string;
  password: string;
  status: string;
  activeBoardUsers: string;
  activeUsers: string;
  campaignCount: number;
  created: string;
  credentialCount: number;
  lastLogin: string;
  name: string;
  ownerName: string;
  timezone: string;
  totalUsers: number;
}

export interface CName {
  accountId: string;
  created: string;
  id: string;
  modified: string;
  name: string;
  hasCdIntegration: boolean;
}

export interface Integration {
  accountId: string;
  cnameId: string;
  created: string;
  id: string;
  modified: string;
  name: string;
  settingsData: any;
  state: string;
  status: string;
  type: string;
  version: number;
  assets: {
    credentials: SocialProfile[];
  };
}
export interface Profile {
  created: string;
  id: string;
  imageLink: string;
  name: string;
  displayName: string;
  network: string;
  networkUsername: string;
  status: string;
}
export interface SocialProfile {
  cName?: CName;
  created: string;
  id: string;
  name: string;
  network: string;
  networkUsername: string;
  status: string;
  type: string;
  isConnected: boolean;
}

export interface User {
  id: string;
  name: string;
  email: string;
  lastLogin: string;
  role: string;
  timezone: string;
}
export interface SocialPost {
  Id: string;
  PostId: string;
  CampaignId: string;
  MessageId: string;
  CredentialId: string;
  LinkId: string;
  LinkIds: string[];
  Created: string;
  Modified: string;
  Status: string; // todo need to define types
  Network: string; // todo need to define types
  RemoteId: string;
  RemoteUrl: string;
  Error: string;
}
export interface OktopostLink {
  Created: string;
  Hash: string;
  LongUrl: string;
  ShortUrl: string;
  Id: string;
  Modified: string;
  AccountId: string;
  CampaignId: string;
  MessageId: string;
  PostId: string;
  PostlogId: string;
  Clicks: number;
  Converts: number;
  CredentialId: string;
}

export enum SocialMessageType {
  linkAttachment = 'link-attachment',
  Image = 'image',
  Video = 'video',
  Text = 'text',
}
type MediaType = 'Image' | 'Video';
export interface SocialPostMessage {
  message: SocialMessage;
  socialPost: SocialPost;
  profile: Profile;
  links: OktopostLink[];
}
export interface SocialMessage {
  Id: string;
  Created: string;
  Modified: string;
  Status: string;
  AccountId: string;
  CreatedBy: string;
  ModifiedBy: string;
  CampaignId: string;
  Network: string;
  Subject: string;
  Message: string;
  Md5: string;
  ImageUrl: string;
  Description: string;
  LinkTitle: string;
  LinkUrl: string;
  Url: string;
  Type: SocialMessageType;
  Clicks: number;
  ChildClicks: number;
  BoardClicks: number;
  Converts: number;
  ChildConverts: number;
  BoardConverts: number;
  ChildrenCount: number;
  Picture: string;
  IsBoardMessage: number;
  Media: Media[];
}
export interface Media {
  Id: string;
  Created: string;
  Modified: string;
  AccountId: string;
  Status: string;
  CreatedBy: string;
  ModifiedBy: string;
  Type: MediaType;
  Size: number;
  Resource: string;
  Name: string;
  Description: string;
}
